import { useEffect, useState } from "react";
import FixedFeeReport, { exportStatementsExcel } from "../components/FixedFeeReport";
import { loadPublicShare } from "../services/fixedFeeService";

// Public, login-free view reached through /share/<client>/<token>.
export default function SharedStatement({ token }) {
  const [state, setState] = useState({ loading: true, share: null, error: "" });

  useEffect(() => {
    loadPublicShare(token)
      .then((share) => setState({ loading: false, share, error: "" }))
      .catch(() => setState({ loading: false, share: null, error: "This page could not be loaded. Please try again." }));
  }, [token]);

  const wrap = { maxWidth: 1040, margin: "0 auto", padding: "24px 16px" };

  if (state.loading) return <div style={wrap}><p className="page-copy">Loading…</p></div>;
  if (!state.share) {
    return (
      <div style={wrap}>
        <article className="panel"><div className="panel-body">
          <h2 className="panel-title">Link not available</h2>
          <p className="page-copy">{state.error || "This link is not valid or has been turned off. Please ask ALM Outsourcing for a new one."}</p>
        </div></article>
      </div>
    );
  }

  const { clientName, statements } = state.share;
  return (
    <div style={wrap}>
      <div className="button-row pnl-print-hide" style={{ justifyContent: "flex-end" }}>
        <button type="button" className="btn btn-primary" onClick={() => window.print()}>Print / Save as PDF</button>
        <button type="button" className="btn btn-muted" onClick={() => exportStatementsExcel(statements, clientName)}>Download Excel</button>
      </div>
      <FixedFeeReport clientName={clientName} statements={statements}
        footer={<div className="pnl-footer"><span>Prepared by ALM Outsourcing Services (Pvt) Ltd. Figures are as published; please contact ALM for any query.</span></div>} />
    </div>
  );
}
